import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  report: OrgDashboardPaymentSummaryReport;
};

export type OrgDashboardPaymentSummaryEntry = {
  currYear: { count: number; amount: number };
  prevYear: { count: number; amount: number };
  allTime: { count: number; amount: number };
};

export type OrgDashboardPaymentSummaryReport = {
  job: OrgDashboardPaymentSummaryEntry;
  internship: OrgDashboardPaymentSummaryEntry;
  jobCredits: OrgDashboardPaymentSummaryEntry;
  internshipCredits: OrgDashboardPaymentSummaryEntry;
  gradFairs: OrgDashboardPaymentSummaryEntry;
  gradProgram: OrgDashboardPaymentSummaryEntry;
  totals: OrgDashboardPaymentSummaryEntry;
};

function mapResponse(response: ApiResponse) {
  return response.report;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) =>
    `/data/orgdashboard/${orgId}/payment-summary`,
  mapResponse,
});

// Exports

export const orgDashboardApiIsomorphicFetchPaymentSummary =
  endpoint.createIsomorphicFetchFn();
